<template>

  <div class="app-container" style="background: #CFCFCF;color: #2980B9;">
    <div style="font-size: 24px; color: #00FDF8; line-height: 50px; background: #304A65;" ><img src="../../public/ipplogo.png" width="40px" height="40px"/>  草地贪夜蛾种群动态测报系统<span style="font-size: 12px;">&nbsp;中国农业科学院植保所</span> </div>
    <div style="margin-top:5px"><span>Step1: 输入地理位置及预测范围 （注意：玉米抽样指标：头/百株 | 小麦抽样指标：头/平米）</span></div>
    <div style="margin-top:15px; color: #2980B9;">
      <el-form ref="form" :inline="true" :model="form" :rules="rules" size="big" label-width="120px">
        <el-form-item label="地理位置" prop="location">
          <el-input v-model="form.location" placeholder="请输入位置" size="big"></el-input>
        </el-form-item>
        <el-form-item>
            <el-button :loading="loading" type="success" icon="el-icon-position" @click="getlocation">自动定位</el-button>
        </el-form-item>
        <el-form-item label="选择寄主">
            <el-select v-model="form.selectedFood" placeholder="寄主" style="width:80%;height:5%" prop="selectedFood">
              <el-option
                v-for="item in foodList"
                :key="item.id"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="预测开始时间">
          <el-date-picker
            v-model="form.startdate"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          />
          <!--<el-date-picker-->
            <!--v-model="form.startdate"-->
            <!--type="date"-->
            <!--placeholder="选择计算开始日期">-->
          <!--</el-date-picker>-->
        </el-form-item>
        <!--<el-form-item label="预测时间范围" prop="radio">-->
            <!--<el-radio border v-model="radio" label="30">30天短期预测</el-radio>-->
            <!--<el-radio border v-model="radio" label="90">90天预测</el-radio>-->
            <!--<el-radio border v-model="radio" label="180">180天预测</el-radio>-->
        <!--</el-form-item>-->

      </el-form>
      <div><span>Step2: 选择预测指标</span></div>
      <div style="margin-top:15px">
        <el-radio-group v-model="form.modeltype" size="medium" @change="changeModel">
          <el-radio border label="发生期预测"></el-radio>
          <el-radio border label="动态数量预测"></el-radio>
        </el-radio-group>
      </div>
      <div v-show="!selectedModelType" style="margin-top:15px">
        <span>田间调查结果: </span>
        <el-select v-model="form.value" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div v-show="selectedModelType" style="margin-top:15px">
        <div><span>Step3: 选择预测参数</span></div>
        <div style="margin-top:15px">
          <el-radio-group v-model="form.parammodeltype" size="medium" @change="changeParamModel">
            <el-radio border label="田间调查经验参数"></el-radio>
            <el-radio border label="实验室测定参数"></el-radio>
          </el-radio-group>
        </div>
        <div style="margin-top:15px"><span>是否总量预测</span></div>
        <div style="margin-top:15px">
          <el-radio-group v-model="form.totalltype" size="medium" @change="changeTotalModel">
            <el-radio border label="预测发生总量"></el-radio>
            <el-radio border label="各龄期发生量"></el-radio>
          </el-radio-group>
        </div>
        <div style="margin-top:15px"><span>是否对数处理</span></div>
        <div style="margin-top:15px">
          <el-radio-group v-model="form.datatype" size="medium" @change="changeDataModel">
            <el-radio border label="原始数据"></el-radio>
            <el-radio border label="对数处理"></el-radio>
          </el-radio-group>
        </div>
        <div style="margin-top:15px">
          <div><span>Step4: 输入田间调查结果</span></div>
        </div>
        <div style="margin-top:15px">
          <el-table :data="initTableData" stripe style="width: 50%; text-align: center; margin: 0 auto;" class="tb-edit" border
                    :header-cell-style="{background:'#3d80f2',color:'#fff',fontSize:'14px',height:'40px'}">
            <el-table-column prop="inputvalue0" label="卵粒">
              <template slot-scope="scope">
                <el-input v-model="scope.row.inputvalue0" placeholder="请输入发生数量"
                          :rules="[
                              { required: true, message: '不能为空'},
                              { type: 'number', message: '必须为数字'}
                            ]"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="inputvalue1" label="1龄幼虫">
              <template slot-scope="scope">
                <el-input v-model="scope.row.inputvalue1" placeholder="请输入发生数量"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="inputvalue2" label="2龄幼虫">
              <template slot-scope="scope">
                <el-input v-model="scope.row.inputvalue2" placeholder="请输入发生数量"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="inputvalue3" label="3龄幼虫">
              <template slot-scope="scope">
                <el-input v-model="scope.row.inputvalue3" placeholder="请输入发生数量"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="inputvalue4" label="4龄幼虫">
              <template slot-scope="scope">
                <el-input v-model="scope.row.inputvalue4" placeholder="请输入发生数量"
                ></el-input>

              </template>
            </el-table-column>
            <el-table-column prop="inputvalue5" label="5龄幼虫">
              <template slot-scope="scope">
                <el-input v-model="scope.row.inputvalue5" placeholder="请输入发生数量"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="inputvalue6" label="6龄幼虫">
              <template slot-scope="scope">
                <el-input v-model="scope.row.inputvalue6" placeholder="请输入发生数量"
                ></el-input>

              </template>
            </el-table-column>
            <el-table-column prop="inputvalue7" label="蛹">
              <template slot-scope="scope">
                <el-input v-model="scope.row.inputvalue7" placeholder="请输入发生数量"
                ></el-input>

              </template>
            </el-table-column>
            <el-table-column prop="inputvalue8" label="成虫">
              <template slot-scope="scope">
                <el-input v-model="scope.row.inputvalue8" placeholder="请输入发生数量"
                ></el-input>

              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <div style="margin-top:15px">
      <el-button type="primary" icon="el-icon-search" :loading="loading2" @click="search('form')">开始预测</el-button>
    </div>
    <!--<div slot="footer" class="dialog-footer">-->
      <!--<div id="myChart" :style="{ height: '600px'}"></div>-->
    <!--</div>-->
    <div style="margin-top:15px">
      <div slot="footer" class="dialog-footer" v-loading="loading2">
        <!--<div id="myChart" :style="{width: '1200px', height: '600px'}"></div>-->
        <div id="myChart" style="height:600px;background:ghostwhite"></div>
        <div class="content" v-if="tableData.length>0 && selectedModelType==false">
          <el-table :data="tableData"
                    tooltip-effect="dark"
                    style="width: 80%; text-align: center; margin: 0 auto;border: 1px solid #68a7f9; "
                    :row-class-name="tableRowClassName"
                    :header-cell-style="{background:'#3d80f2',color:'#fff',fontSize:'16px',height:'55px'}">
            <el-table-column prop="phase" label="阶段"></el-table-column>
            <el-table-column prop="method" label="防治方法"></el-table-column>
            <el-table-column prop="startDate" label="开始日期"></el-table-column>
            <el-table-column prop="endDate" label="结束日期"></el-table-column>
          </el-table>
        </div>
        <div class="content" v-if="selectedModelType">
          <div style="margin-top:5px"><el-tag type="danger">田间调查幼虫总量：{{sumData}}头/百株</el-tag></div>
          <div style="margin-top:15px">
            <el-tag type="success">种群动态预测数据：</el-tag>
            <el-input
            type="textarea"
            autosize
            :rows="2"
            placeholder="请输入内容"
            v-model="textarea">
          </el-input></div>
          <div style="margin-top:5px">
            <el-table :data="newtableData"
                      tooltip-effect="dark"
                      style="width: 80%; text-align: center; margin: 0 auto;border: 1px solid #68a7f9; "
                      :row-class-name="tableRowClassName"
                      :header-cell-style="{background:'#3d80f2',color:'#fff',fontSize:'16px',height:'55px'}">
              <el-table-column prop="status" label="虫情"></el-table-column>
              <el-table-column prop="method" label="防治方法"></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import {getWeatherDataNew,getDataNew,getUserLocation,DateTimeFormatter} from '@/api/Weather'
//    import {getUserLocation} from '@/api/Weather'

    export default {
        name: 'HelloWorld',
        data() {
            return {
                msg: '草地贪夜蛾种群动态预测',
                sumData:'',
                textarea: '',
                foodList: [{ id: '1',name: '玉米'},{ id: '2',name: '小麦'},{ id: '3',name: '高粱'},{ id: '4',name: '大豆'},{ id: '5',name: '花生'},{ id: '6',name: '向日葵'},{ id: '7',name: '油菜'},{ id: '8',name: '人工饲料'}],
                tableData: [],
                loading: false,
                loading2: false,
                userlocation: '',
                selectedModelType: false,
                selectedParamType: 'limei',
                selectedTotalType: 'divide',
                selectedDataType: 'original',
                inputvalue0: '',
                inputvalue1: '',
                inputvalue2: '',
                pickerOptions: {
                shortcuts: [{
                  text: '最近一周',
                  onClick(picker) {
                    const end = new Date()
                    const start = new Date()
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                    picker.$emit('pick', [start, end])
                  }
                }, {
                  text: '最近一个月',
                  onClick(picker) {
                    const end = new Date()
                    const start = new Date()
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                    picker.$emit('pick', [start, end])
                  }
                }, {
                  text: '最近三个月',
                  onClick(picker) {
                    const end = new Date()
                    const start = new Date()
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                    picker.$emit('pick', [start, end])
                  }
                }]
              },
                radio: '30',
                form: {location: '', value: '',selectedFood:'玉米', modeltype: '发生期预测',parammodeltype: '田间调查经验参数',totalltype:'各龄期发生量',datatype:'原始数据',startdate:Date.now(),},
                initTableData: [{inputvalue0:'0',inputvalue1:'0',inputvalue2:'0',inputvalue3:'0',inputvalue4:'0',inputvalue5:'0',
                    inputvalue6:'0',inputvalue7:'0',inputvalue8:'0',}],

      rules: {
        location: [
          { required: true, message: '请输入地理位置', trigger: 'blur' },
          { min: 2, max: 30, message: '长度在 2 到 30 个字符', trigger: 'blur' }
        ],
        value: [
          { required: true, message: '田间调查结果不能为空', trigger: 'blur' }
        ],
        selectedFood: [
          { required: true, message: '请选择寄主', trigger: 'blur' }
        ],
        inputvalue0:[{pattern: /^-?\d+\.?\d*$/, message: '请输入数字', trigger: 'blur' }],
      },
//              initrules:{
//                inputvalue0:[{pattern: /^-?\d+\.?\d*$/, message: '请输入数字', trigger: 'blur' }],
//                inputvalue1:[{pattern: /^-?\d+\.?\d*$/, message: '请输入数字', trigger: 'blur' }],
//
//              },
//      activeName: 'first',
      options: [{
        value: '0',
        label: '卵块'
      }, {
        value: '1',
        label: '1龄幼虫'
      }, {
        value: '2',
        label: '2龄幼虫'
      }, {
        value: '3',
        label: '3龄幼虫'
      }, {
        value: '4',
        label: '4龄幼虫'
      }, {
        value: '5',
        label: '5龄幼虫'
      }, {
        value: '6',
        label: '6龄幼虫'
      }, {
        value: '7',
        label: '蛹'
      }, {
        value: '8',
        label: '成虫'
      }],
      value: '',
      newtableData: [{
        status: '百株虫量 < 10头',
        method: '保持观察'
      }, {
        status: '10头 < 百株虫量 < 20头',
        method: '采用生物农药或生物防治方法'
      }, {
        status: '百株虫量 > 20头',
        method: '化学农药'
      }]
    }
  },
  mounted(){
//    this.drawLine();
//    this.drawdataLine();
  },
  methods: {

//  search(ip) {
//      getLocation(ip).then(result => {
//        this.drawVolumeLine(result.data);
////        console.log(result)
//    }).catch(function(error) {
//        console.log(error);
//      });
//    },
    Datepad(d){
      var ye = d.getFullYear();
      var mo = (d.getMonth()+1).toString().padStart(2,'0');
      var da = d.getDate().toString().padStart(2,'0');
      var time = ye+'-'+mo+'-'+da;
      return time
    },

    changeModel(value){

      if(value=="动态数量预测"){
        this.selectedModelType = true;
      }else
      {
        this.selectedModelType = false;
      }
//      console.log(value);
    },
    changeTotalModel(value){
      if(value=="预测发生总量"){
        this.selectedTotalType = 'total';
      }else
      {
        this.selectedTotalType = 'divide';
      }
//      console.log(value);
    },
    changeDataModel(value){
      if(value=="原始数据"){
        this.selectedDataType = 'original';
      }else
      {
        this.selectedDataType = 'log';
      }
//      console.log(value);
    },
    changeParamModel(value){

      if(value=="实验室测定参数"){
        //如果是实验室测定参数，采用helimei测定的实验室参数，从数据库中获取 5002
//        var _this = this;
        this.selectedParamType = 'limei';
//        alert(this.selectedParamType);
      }else
      {
        //采用hewei测定的田间调查经验参数,hard coding 5001
        this.selectedParamType = 'hewei';
      }
//      console.log(value);
    },
    getlocation(){
      let that = this;
      that.loading = true;
      var geolocation = new BMap.Geolocation();
      // 开启SDK辅助定位
      geolocation.enableSDKLocation();
      geolocation.getCurrentPosition(function(r) {
        if (this.getStatus() == BMAP_STATUS_SUCCESS) {
//          var mk = new BMap.Marker(r.point);
//          alert('您的位置：' + r.point.lng + ',' + r.point.lat);
          getUserLocation(r.point.lng, r.point.lat).then(
                  result => {
                    that.form.location = result.data['locationName'];
                    console.log(result.data['locationName']);
              }
          ).catch(function(error) {
            console.log(error);
          });
//          this.form.location = ;
//          $("#mylocation").text("自动定位");
                        that.loading = false;
                    } else {
                        alert('failed状态' + this.getStatus());
                        that.loading = false;
                    }
                });
            },
            search(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        let that = this;
                        that.loading2 = true;
//                        alert(that.selectedModelType);
//                      alert(that.selectedParamType);
                        if (that.selectedModelType==false)
                        {
                            that.tableData=[];
                            getWeatherDataNew(that.form.location, that.form.value, DateTimeFormatter(that.form.startdate[0]),DateTimeFormatter(that.form.startdate[1])).then(result => {
                            //  getWeatherDataNew(that.form.location, that.form.value, that.radio,DateTimeFormatter(that.form.startdate)).then(result => {
                                this.drawLine(result.data);
                                console.log(result.data)
                                that.loading2 = false;
                            }).catch(function (error) {
                                console.log(error);
                                that.loading2 = false;
                            });
                        }
                        else
                        {

                            that.tableData=[];
                            let fawData=[];
//                            let port = '';
//                            if (that.selectedParamType==false){
//                              alert('hewei');
//                              port = '5001';
//                            }else
//                            {
//                              alert('limei');
//                              port = '5002';
//                            }
                            fawData.push(that.initTableData[0].inputvalue0);
                            fawData.push(that.initTableData[0].inputvalue1);
                            fawData.push(that.initTableData[0].inputvalue2);
                            fawData.push(that.initTableData[0].inputvalue3);
                            fawData.push(that.initTableData[0].inputvalue4);
                            fawData.push(that.initTableData[0].inputvalue5);
                            fawData.push(that.initTableData[0].inputvalue6);
                            fawData.push(that.initTableData[0].inputvalue7);
                            fawData.push(that.initTableData[0].inputvalue8);
                            console.log(fawData.toString().replace(/,/g,"-"));
                            that.sumData = parseInt(that.initTableData[0].inputvalue1)+parseInt(that.initTableData[0].inputvalue2)+parseInt(that.initTableData[0].inputvalue3)+
                              parseInt(that.initTableData[0].inputvalue4)+parseInt(that.initTableData[0].inputvalue5)+parseInt(that.initTableData[0].inputvalue6);
//                            console.log(that.selectedParamType);

                          console.log(that.form.selectedFood)
                          console.log(that.selectedDataType)
                          getDataNew(that.form.location, fawData.toString().replace(/,/g,"-"), DateTimeFormatter(that.form.startdate[0]),DateTimeFormatter(that.form.startdate[1]),that.selectedParamType,that.form.selectedFood,that.selectedTotalType,that.selectedDataType).then(result => {
//                            getDataNew(that.form.location, fawData.toString().replace(/,/g,"-"), that.radio,DateTimeFormatter(that.form.startdate),that.selectedParamType,that.form.selectedFood,that.selectedTotalType).then(result => {
                            //getDataNew(that.form.location, fawData.toString().replace(/,/g,"-"), that.radio,DateTimeFormatter(that.form.startdate),that.selectedParamType,that.form.selectedFood).then(result => {
//                                console.log(result)
//                                this.drawdataLine(result.data);
                              if (that.selectedTotalType==='total')
                                {
                                  this.drawtotaldataLine(result.data);
                                }
                              else
                                {
                                  this.drawdataLine(result.data);
                                }

                                that.textarea = JSON.stringify(result.data);
                                that.loading2 = false;
                            }).catch(function (error) {
                                console.log(error);
                                that.loading2 = false;
                            });
                        }

                    } else {
                        console.log("error submit!!");
                        return false;
                    }
                });
            },
            //   表格各行变色
            tableRowClassName({row, rowIndex}) {
                if (rowIndex % 2 == 0) {
                    return "warning-row";
                } else {
                    return "success-row";
                }
            },
            drawLine(result) {
                let that = this;
                let markArea = [];
                let markAreaColor = [{name: '卵', color: '#FFFACD'},
                    {name: '1龄幼虫', color: '#FFA54F'},
                    {name: '2龄幼虫', color: '#2a81cd'},
                    {name: '3龄幼虫', color: '#23b2ff'},
                    {name: '4龄幼虫', color: '#bf4385'},
                    {name: '5龄幼虫', color: '#CD2626'},
                    {name: '6龄幼虫', color: '#c773cd'},
                    {name: '蛹', color: '#1fc6cd'},
                    {name: '成虫', color: '#39cd42'}];
                let datatmp = [];

      result.duration.forEach(item => {
        let data = [];
        datatmp.push({
          phase: item[0],
          method: item[1],
          startDate: item[2],
          endDate: item[3]
        });
        let color = '#' + ('00000' + (Math.random() * 0x1000000 << 0).toString(16)).substr(-6);
        markAreaColor.map(function (coloritem) {
          if (item[0] == coloritem.name) {
            console.log('coloritem.color:' + coloritem.color)
            color = coloritem.color;
          }
        })
        data.push({
          name: item[0],
          xAxis: item[2],
          itemStyle: {
            color: color,
            fontSize: '8px'
          }
        });
        data.push(
          {
            xAxis: item[3]
          }
        )
        markArea.push(data);
      });

      that.tableData = datatmp;
      console.log(that.tableData);
      console.log(markArea);

      let myChart = this.$echarts.init(document.getElementById('myChart'))
      myChart.clear();
      myChart.setOption({
        title: {
          text: '草地贪夜蛾积温预测',
          subtext: '日平均积温法'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['最高气温', '最低气温']
        },
        toolbox: {
          show: true,
          feature: {
            dataZoom: {
              yAxisIndex: 'none'
            },
            dataView: {readOnly: false},
            magicType: {type: ['line', 'bar']},
            restore: {},
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            show: true,
            textStyle: {
              color: '##00FDF8'
            }
          },
          boundaryGap: false,
          data: result['temp'].map(function (item) {
            console.log(item['Date']);
            return item['Date'];
          })
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value} °C',
            show: true,
            textStyle: {
              color: '##00FDF8'
            }
          }
        },
        series: [
          {
            name: '最高气温',
            type: 'line',
            areaStyle: {},
            data: result['temp'].map(function (item) {
              console.log(item['maxTem']);
              return item['maxTem'];
            }),
            markPoint: {
              data: [
                {type: 'max', label:'最大值',name: '最大值'},
                {type: 'min', name: '最小值'},
//                {name: '坐标', coord: ['2020-3-27', 20],label:'预测羽化日'}
                                ]
                            },
                            markLine: {
                                data: [
                                    {type: 'average', name: '平均值'},
//                                    {
//                                        name: '发育起点温度',
//                                        yAxis: 12,
//                                        symbol: 'rect',
//                                        lineStyle: {color: 'black', width: '3'},
//                                        label: '发育起点温度'
//                                    },
                                    {
                                        name: '发育停止温度',
                                        yAxis: 38,
                                        symbol: 'rect',
                                        lineStyle: {color: 'red', width: '3'},
                                        label: '发育停止温度'
                                    },
                                ]
                            }
                        },
                        {
                            name: '最低气温',
                            type: 'line',
                            areaStyle: {},
                            data: result['temp'].map(function (item) {
                                console.log(item['minTem']);
                                return item['minTem'];
                            }),
                            markPoint: {
                                data: [
//                {name: '周最低', value: -2, xAxis: 1, yAxis: -1.5}
              ]
            },
            markLine: {
              data: [
                {type: 'average', name: '平均值'},
//                [{
//                  symbol: 'none',
//                  x: '90%',
//                  yAxis: 'max'
//                }, {
//                  symbol: 'circle',
//                  label: {
//                    position: 'start',
//                    formatter: '最大值'
//                  },
//                  type: 'max',
//                  name: '最高点'
//                }]
                                ]
                            },
                            markArea: {
                                data: markArea
                            },
                        }
                    ]
                });
            },
            drawdataLine(result) {
                let Date=result.DateList;
                Date.splice(0, 0, "product");
                let data=result.DataList;

                let seriesData=[];
                let sourcedata=[];
                sourcedata.push(Date);

                data.forEach(item => {
                    let items=item.split(',');
                    sourcedata.push(items)
                    seriesData.push({type: 'line', smooth: true, seriesLayoutBy: 'row'})
                });
                seriesData.push( {
                    type: 'pie',
                    id: 'pie',
                    radius: '30%',
                    center: ['50%', '35%'],
                    label: {
                        formatter: '{b}: {@'+Date[1]+'} ({d}%)'
                    },
                    encode: {
                        itemName: 'product',
                        value: Date[1],
                        tooltip: Date[1]
                    }
                })
                console.log(sourcedata);
                console.log(seriesData);

                let myChart = this.$echarts.init(document.getElementById('myChart'))
                myChart.clear();
                setTimeout(function () {

                    var option = {
                        legend: {
                        },
                        tooltip: {
                            trigger: 'axis',
                            showContent: true
                        },
                      toolbox: {
                        show: true,
                        feature: {
//                          logButtons:{//自定义按钮
//                                      show:true,//是否显示
//                                      title:'对数处理', //鼠标移动上去显示的文字
//                                      icon:'../assets/logo.png', //图标
//                                      option:{
//
//                                      },
////                            {
//                              //点击事件,这里的option1是chart的option信息
////                              opt1.series.forEach(function(e) {
////                                e.type = "line";
////                                e.stack = null;
////                              });
////                              chart.setOption(opt1);
//
////                            }
//                          },
                          dataZoom: {
                            yAxisIndex: 'none'
                          },
                          dataView: {readOnly: false},
                          magicType: {type: ['line', 'bar']},
                          restore: {},
                          saveAsImage: {}
                        }
                      },
                        dataset: {
                            source: sourcedata
                        },
                        xAxis: {name: '日期',type: 'category'},
                        yAxis: {name: '发生数量',gridIndex: 0},
                        grid: {top: '55%'},
                        series: seriesData
                    };

        myChart.on('updateAxisPointer', function (event) {
          var xAxisInfo = event.axesInfo[0];
//          console.log(event)
          if (xAxisInfo) {
            var dimension = xAxisInfo.value + 1;
            myChart.setOption({
              series: {
                id: 'pie',
                label: {
                  formatter: '{b}: {@[' + dimension + ']} ({d}%)'
                },
                encode: {
                  value: dimension,
                  tooltip: dimension
                }
              }
            });
          }
        });

        myChart.setOption(option);

      });
    },
            drawtotaldataLine(result) {
      let Date=result.DateList;
      Date.splice(0, 0, "product");
      let data=result.DataList;
      let myChart = this.$echarts.init(document.getElementById('myChart'))
      myChart.clear();
      setTimeout(function () {
        var option = {
          legend: {
          },
          toolbox: {
            show: true,
            feature: {
              dataZoom: {
                yAxisIndex: 'none'
              },
              dataView: {readOnly: false},
              magicType: {type: ['line', 'bar']},
              restore: {},
              saveAsImage: {}
            }
          },
          xAxis: {name: '日期',type: 'category',data:Date },
          yAxis: {name: '卵、幼虫、蛹、成虫的总量',type:'value'},
          series: [{
            data: data,
            type: 'line',
            smooth: true
          }]
        };

        myChart.setOption(option);

      });
    }

  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .el-table .warning-row {
    background: #f4f8fe;
  }

  .el-table .success-row {
    background: #fff;
  }
</style>
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
